import { Badge, Tooltip } from '@shared/components';
import type { GeneratedDocument } from '../../types/agreementDocuments.types';
import { DOCUMENT_STATUS_BADGE, failureSummary, isStillGenerating } from '../../utils/generatedDocumentDisplay';

interface Props {
    document: GeneratedDocument;
    now: number;
    showFailure?: boolean;
}

export function DocumentStatusCell({ document, now, showFailure = true }: Props) {
    const badge = DOCUMENT_STATUS_BADGE[document.status];
    const emptyCount = document.emptyVariables.length;

    return (
        <div className="space-y-1">
            <div className="flex flex-wrap items-center gap-1.5">
                <Badge variant={isStillGenerating(document, now) ? 'warning' : badge.variant}>
                    {isStillGenerating(document, now) ? 'Still generating' : badge.label}
                </Badge>
                {emptyCount > 0 && (
                    <Tooltip content={`Rendered empty: ${document.emptyVariables.join(', ')}`}>
                        <Badge variant="warning">{emptyCount === 1 ? '1 empty field' : `${emptyCount} empty fields`}</Badge>
                    </Tooltip>
                )}
            </div>
            {showFailure && document.failure && <p className="text-xs text-mp-error">{failureSummary(document.failure, document.id)}</p>}
        </div>
    );
}
